// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-my-datasources .ac-grid__results-count{position:fixed;right:16px;bottom:16px}\n", ""]);
// Exports
module.exports = exports;
